import { Loader } from '@grafikr/components';

import { NonNullish } from 'utils/nullish-check';

export default Loader(({ node }, load) => {
  const target = NonNullish(node.dataset.loadTarget, 'on-element-interaction');
  const targets = document.querySelectorAll<HTMLElement>(`[data-load="${target}"]`);

  targets.forEach((element) => {
    const event = element.dataset.event || 'click';
    element.addEventListener(event, load, { passive: true });
  });
});
